/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Summary_HeadlineInputs */

const en_us2_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Month`);
	return /** @type {LocalizedString} */ (`Year`)
	
};

const pt_br2_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Mês`);
	return /** @type {LocalizedString} */ (`Ano`)
	
};

const es_419_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Mes`);
	return /** @type {LocalizedString} */ (`Año`)
	
};

const pt_pt2_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Mês`);
	return /** @type {LocalizedString} */ (`Ano`)
	
};

const fr_fr2_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Mois`);
	return /** @type {LocalizedString} */ (`Année`)
	
};

const de_de2_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Monat`);
	return /** @type {LocalizedString} */ (`Jahr`)
	
};

const it_it2_wrapped_period_summary_headline = /** @type {(inputs: Wrapped_Period_Summary_HeadlineInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Mese`);
	return /** @type {LocalizedString} */ (`Anno`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "Month" |
* | * | "Year" |
*
* @param {Wrapped_Period_Summary_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_summary_headline = /** @type {((inputs: Wrapped_Period_Summary_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Summary_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_summary_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_period_summary_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_summary_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_summary_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_summary_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_summary_headline(inputs)
	return en_us2_wrapped_period_summary_headline(inputs)
});
export { wrapped_period_summary_headline as "wrapped-period.summary_headline" }